module.exports = __webpack_public_path__ + "assets/img/details_background.09952703.png";